































import { Component, Vue, Prop } from 'vue-property-decorator';
import LoadableButton from "@/shared/components/ui/LoadableButton.vue";
import AppModal from '@/shared/components/ui/Modal.vue';

@Component({
    components: {
        AppModal,
        LoadableButton
    },
})
export default class Bid extends Vue {
    @Prop() open!: boolean;
    @Prop() contestId!: any;
    @Prop() contestName!: string;

    private loading = false;
    private bidValue = 0;

    private increase() {
        this.bidValue = this.bidValue + 1;
    }

    private decrease() {
        this.bidValue = this.bidValue - 1;
    }

    private close() {

    }
}
